import { z } from 'zod';
import { Language } from '@prisma/client';
import { arrayToNonEmptyArray } from './array-to-non-empty-array';

export const languageZodEnum = () =>
  z
    .enum(arrayToNonEmptyArray(Object.values(Language)))
    .transform((value) => Language[value as keyof typeof Language] as Language);
